import { Icons } from '@lemon/assets';
import { Goods } from '../../goods/Goods';

export const GoodsPage = () => {
    return (
        <div className="w-full min-h-screen flex justify-center">
            <div className="w-full max-w-[480px]">
                <div className="w-full h-14 flex justify-between items-center">
                    <img src={Icons.logo} alt="logo" />
                    <img src={Icons.search} alt="search" />
                </div>
                <Goods />
            </div>
        </div>
    );
};
